export const buzzerStyles = `
  .notification-buzzer {
    position: absolute;
    display: flex;
    align-items: center;
  }
  
  .notification-buzzer .count {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background-color: #e60023;
  color: white;
  font-size: 12px;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
  line-height: 1;
  border-radius: 50%;
  position: absolute;
  top: -35px;
  left: -45px;
}
`;